module.exports = __webpack_public_path__ + "static/img/6.076ad0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/6.jpg
// module id = Jbue
// module chunks = 1